module.exports = __webpack_public_path__ + "static/media/imagebox_2.759ed348.jpg";